
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import ListProducts from './ListProducts';
import { useRefresh } from '../../hooks/useRefresh';

function Index({SetshowExecutiveMenu}) { 
 const {change, getInitData} = useRefresh();
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
     const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [dishs, setdishs] = useState(false);


      useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
               
            });
      }, [menus]);
    

    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent
            setShowSpecials={() => {
            setdishs(drinks)
            setShowListProduct(true)
        }} 
                goCategories={setshowCategories} showredes={false} showBack={true} setShowListProduct={SetshowExecutiveMenu}>
                <img
                    src={require('./assets/mundialscren.png')}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: 0,
                    }}
                />

                 {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={SetshowExecutiveMenu} />}
                  {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            </LayoutContent>
        </div>
    );
}
export default Index;